/**
 * "Guides" overview — Guides section (ADR-0074).
 * Task-oriented how-tos that compose the reference docs into end-to-end flows.
 * Every guide links to the canonical pages rather than restating them.
 */
import type { DocPageContent } from '../types';

export const GUIDES_OVERVIEW_PAGE: DocPageContent = {
  slug: 'guides',
  titleKey: 'docs.guides.overview.title',
  descriptionKey: 'docs.guides.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.overview.lead' },

    { kind: 'heading', level: 2, id: 'guides', textKey: 'docs.guides.overview.list.heading' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.overview.card.launch.title',
          textKey: 'docs.guides.overview.card.launch.text',
          to: { docSlug: 'guides/launch-assistant' },
        },
        {
          titleKey: 'docs.guides.overview.card.mcp.title',
          textKey: 'docs.guides.overview.card.mcp.text',
          to: { docSlug: 'guides/connect-mcp' },
        },
        {
          titleKey: 'docs.guides.overview.card.knowledge.title',
          textKey: 'docs.guides.overview.card.knowledge.text',
          to: { docSlug: 'guides/ground-knowledge' },
        },
        {
          titleKey: 'docs.guides.overview.card.actAsUser.title',
          textKey: 'docs.guides.overview.card.actAsUser.text',
          to: { docSlug: 'guides/act-as-user' },
        },
        {
          titleKey: 'docs.guides.overview.card.production.title',
          textKey: 'docs.guides.overview.card.production.text',
          to: { docSlug: 'guides/go-to-production' },
        },
      ],
    },

    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.guides.overview.start.title',
      textKey: 'docs.guides.overview.start.body',
      links: {
        quickstart: {
          target: { docSlug: 'quickstart' },
          labelKey: 'docs.guides.overview.start.link',
        },
      },
    },
  ],
};
